import { RootState } from 'modules'
import { ILarinVariant } from 'pages/StudentPage/components/LarinVariants'

export const selectLarinVariants = (
  state: RootState
): Array<ILarinVariant> | null => state.larinVariants
